const translations = {
  header: {
    name: {
      pt: "Estúdio Fehra",
      en: "Fehra Studio",
    },
  },
  intro: {
    text: {
      pt: "Somos um estúdio de tecnologia e design que cria experiências interativas, produtos digitais e conduz processos de inovação, conectando marcas e pessoas dentro e fora das telas.",
      en: "We're a tech and design studio creating interactive experiences, digital products, and innovation journeys that connect brands and people—on screen and beyond.",
    },
  },
  about: {
    title: {
      pt: "Sobre",
      en: "About",
    },
    subtitle: {
      pt: "Lidamos com o que ainda não tem forma ou mesmo nome com maestria e sensibilidade.",
      en: "With a blend of skill and sensitivity, we give shape to what doesn’t yet have a name or a form.",
    },
    text: {
      pt: "Fundamos a Fehra e escolhemos esse nome para provocar rupturas: rugir, agir, arranhar. Acreditamos que a lógica precisa estar aliada ao instinto para que imaginemos soluções criativas que realmente rompam com os padrões que já não funcionam. Trabalhamos juntos há mais de 15 anos neste mercado e, nesse tempo, já fizemos de tudo: de um prédio que se mexia durante as Olimpíadas a uma experiência em realidade aumentada para o Spotify. A cada projeto, para dar vida às criações, convocamos uma rede de especialistas que fazem parte da nossa selva.",
      en: "We founded Fehra and choose this name to rattle the cage: roar, act, scratch. We believe logic and instinct must work side by side to imagine creative solutions that break free from patterns that no longer serve us. We've been building together for over 15 years—everything from a moving building at the Olympics to an augmented reality experience for Spotify. To bring each idea to life, we call upon a network of collaborators who are part of our jungle.",
    },
  },
  clients: {
    title: {
      pt: "Clientes",
      en: "Clients",
    },
  },
  services: {
    title: {
      pt: "O que fazemos",
      en: "What we do",
    },
    description: {
      pt: "Nossas propostas são sempre feitas sob medida, mas costumam se agrupar em algumas categorias principais:",
      en: "Our proposals are always tailor-made, but they tend to fall into a few key categories:",
    },
    digital: {
      title: {
        pt: "Experiências Digitais",
        en: "Digital Experiences",
      },
      text: {
        pt: "Num mundo digital cada vez mais saturado, criamos produtos que combinam clareza, elegância e encantamento. Oferecemos experiências completas, de ponta a ponta: do mapeamento da jornada até interfaces intuitivas — incluindo arquitetura da informação, infraestrutura de tecnologia, desenvolvimento front e back-end.",
        en: "In a digital world that gets more saturated by the day, we design products that combine clarity, elegance, and joy. We craft full experiences—end to end—from user journey mapping to intuitive interfaces, including information architecture, tech infrastructure, and both front- and back-end development.",
      },
    },
    phygital: {
      title: {
        pt: "Figital",
        en: "Phygital",
      },
      text: {
        pt: "Criamos experiências que mesclam físico e digital de forma significativa, despertando presença e conexão. Perfeitas para marcas que querem impactar em espaços e eventos onde seu público está.",
        en: "We create experiences that blend physical and digital in meaningful ways, evoking presence and fostering connection. Ideal for brands wanting to make an impact where their audience gathers—online or off.",
      },
    },
    consulting: {
      title: {
        pt: "Consultoria de Inovação",
        en: "Innovation Consulting",
      },
      text: {
        pt: "Através de sprints e workshops imersivos, ajudamos a resolver desafios de negócio em tempo recorde. Projetamos processos de inovação, lançamos iniciativas ousadas e testamos novas ideias de produtos.",
        en: "Through sprints and immersive workshops, we help solve business challenges fast. We design innovation processes, launch bold initiatives, and test new product ideas.",
      },
    },
    branding: {
      title: {
        pt: "Branding",
        en: "Branding",
      },
      text: {
        pt: "Mergulhamos na estratégia do seu negócio para descobrir o que sua marca quer inspirar e comunicar ao mundo. A partir disso, criamos o conceito, a identidade visual e todos os ativos para lançar ou reinventar sua marca.",
        en: "We go deep into your business strategy to uncover what your brand wants to say and how it wants to be remembered. From there, we shape the concept, build the visual identity, and create all the assets to launch or reinvent your brand.",
      },
    },
  },
  footer: {
    contactTitle: {
      pt: "Tem um projeto? Vamos conversar",
      en: "Have a project? Let's talk",
    },
    followUs: {
      pt: "Siga a gente",
      en: "Follow us",
    },
    copyright: {
      pt: "Todos direitos reservados © 2025",
      en: "All rights reserved © 2025",
    },
    backToTop: {
      pt: "Ir para o topo ↑",
      en: "Back to top ↑",
    },
  },
  tags: {
    digital: {
      pt: "Experiências Digitais",
      en: "Digital Experiences",
    },
    phygital: {
      pt: "Figital",
      en: "Phygital",
    },
    branding: {
      pt: "Branding",
      en: "Branding",
    },
    consulting: {
      pt: "Consultoria em Inovação",
      en: "Innovation Consulting",
    },
    ux: {
      pt: "User Experience",
      en: "User Experience",
    },
    interface: {
      pt: "Interface",
      en: "Interface",
    },
    prototyping: {
      pt: "Prototipação",
      en: "Prototyping",
    },
    motion: {
      pt: "Motion Design",
      en: "Motion Design",
    },
    mobile: {
      pt: "Desenvolvimento Mobile",
      en: "Mobile Development",
    },
    web: {
      pt: "Desenvolvimento Web",
      en: "Web Development",
    },
    software: {
      pt: "Arquitetura de Software",
      en: "Software Architecture",
    },
    ai: {
      pt: "Inteligência Artificial",
      en: "Artificial Intelligence",
    },
    frontend: {
      pt: "Front-End",
      en: "Front-End",
    },
    backend: {
      pt: "Back-End",
      en: "Back-End",
    },
    immersive: {
      pt: "Experiências Imersivas",
      en: "Immersive Experiences",
    },
    activation: {
      pt: "Ativação de Marca",
      en: "Brand Activation",
    },
    installations: {
      pt: "Instalações tecnológicas",
      en: "Tech Installations",
    },
    creative: {
      pt: "Creative Coding",
      en: "Creative Coding",
    },
    interaction: {
      pt: "Design de Interação",
      en: "Interaction Design",
    },
    smartObjects: {
      pt: "Smart Objects",
      en: "Smart Objects",
    },
    productMgmt: {
      pt: "Gestão de Produto",
      en: "Product Management",
    },
    productVision: {
      pt: "Visão de Produto",
      en: "Product Vision",
    },
    mvp: {
      pt: "Priorização e Desenho de MVP",
      en: "MVP Prioritization and Design",
    },
    sprint: {
      pt: "Design Sprint",
      en: "Design Sprint",
    },
    serviceDesign: {
      pt: "Design de Serviço",
      en: "Service Design",
    },
    roadmap: {
      pt: "Estratégia e Roadmap",
      en: "Strategy and Roadmap",
    },
    research: {
      pt: "Product Research",
      en: "Product Research",
    },
    visualId: {
      pt: "Identidade Visual",
      en: "Visual Identity",
    },
    brandStrategy: {
      pt: "Estratégia de Marca",
      en: "Brand Strategy",
    },
    territory: {
      pt: "Território de Marca",
      en: "Brand Territory",
    },
    logo: {
      pt: "Logo Design",
      en: "Logo Design",
    },
    manual: {
      pt: "Manual de Marca",
      en: "Brand Guidelines",
    },
    visualSystem: {
      pt: "Sistema Visual",
      en: "Visual System",
    },
  },
  project: {
    tera: {
      pt: "Escola de inteligência artificial de uma das principais comunidades de tecnologia e educação do Brasil.",
      en: "An AI school born from one of Brazil’s leading tech and education communities.",
    },
    aleph: {
      pt: "Criação do universo expandido do livro, uma plataforma acessível via QR Code para aproximar leitores e histórias.",
      en: "Expanded a book’s universe through a QR-code platform that connects readers and stories.",
    },
    lgbtflix: {
      pt: "Plataforma de streaming gratuita com filmes dirigidos por pessoas LGBT ou com essa temática.",
      en: "A free streaming platform showcasing films by and about the LGBT community.",
    },
    freela: {
      pt: "Plataforma onde profissionais da criatividade encontram ferramentas para crescer em suas carreiras.",
      en: "A platform where creative professionals can find tools to grow their careers.",
    },
    chagas: {
      pt: "Transformamos um banco de dados internacional complexo em informação clara e acessível sobre a Doença de Chagas.",
      en: "We turned a complex international database into clear, accessible information about Chagas disease.",
    },
    marko: {
      pt: "Portfólio digital para o Atelier Marko Brajovick, inspirado pela presença e formas do design em ecossistemas naturais.",
      en: "Digital portfolio for Atelier Marko Brajovick, inspired by the presence and forms of design in natural ecosystems.",
    },
    comgas: {
      pt: "Processo de cinco dias para desenvolver estratégia, naming e plano de lançamento para uma iniciativa de energia renovável.",
      en: "A five-day process to develop the strategy, naming, and launch plan for a renewable energy initiative.",
    },
    firjan: {
      pt: "Imersão de cinco dias para prototipar um produto que engaja estudantes com as iniciativas da rede Sesi.",
      en: "A five-day immersion to prototype a product that engages students with Sesi network initiatives.",
    },
    pixel: {
      pt: "Direção criativa, desenvolvimento e produção das salas da primeira arena de jogos interativos do Brasil.",
      en: "Creative direction, development, and production of Brazil’s first interactive gaming arena.",
    },
    ultravioleta: {
      pt: "Experiência de boas-vindas para os visitantes da Casa Nubank Ultravioleta. Um tronco de madeira tecnológico apresenta diferentes modos de interação.",
      en: "Welcome experience for Casa Nubank Ultravioleta visitors. A tech-augmented wooden trunk offers different interactive modes.",
    },
    precioso: {
      pt: "Peça de arte, ambiente-interface programável de som, imagem, vídeo e luz que conta a história do objeto que emerge do centro.",
      en: "Art piece, an interactive environment of sound, image, video, and light telling the story of the object that emerges from the center.",
    },
    saudade: {
      pt: "Luminária para ter em dupla: você a toca e o objeto acende na casa da outra pessoa.",
      en: "Paired lamp: you touch it, and the other lights up in someone else’s home.",
    },
    iguatemi: {
      pt: "Escultura de luz interativa em movimento que convida para um evento de moda e inovação.",
      en: "A moving, interactive light sculpture inviting people to a fashion and innovation event.",
    },
    araquem: {
      pt: "Dispositivo que captura imagem e geolocalização de  exposição itinerante pelos rios da Amazônia e as transmite em uma experiência digital.",
      en: "Device that captures imagery and geolocation from a traveling exhibition through the Amazon rivers, delivered as a digital experience.",
    },
    cultura: {
      pt: "Conceito, identidade visual e plataforma digital para a 28 edição do Festival em São Paulo.",
      en: "Concept, visual identity, and digital platform for the 28th edition of the Festival in São Paulo.",
    },
    studio92: {
      pt: "Rebranding para reforçar o posicionamento do studio como escritório de arquitetura que valoriza as histórias e seus afetos.",
      en: "Rebranding to reinforce the studio’s positioning as an architecture firm that values stories and emotional connections.",
    },
  },
};

export function translate(key, lang = "pt") {
  const parts = key.split(".");
  let result = translations;

  for (const part of parts) {
    if (result[part]) {
      result = result[part];
    } else {
      console.warn(`⚠️ Tradução ausente para chave: "${key}"`);
      return key;
    }
  }

  if (!result?.[lang]) {
    console.warn(
      `⚠️ Tradução ausente para idioma "${lang}" na chave: "${key}"`
    );
  }

  return result?.[lang] || key;
}

export default translations;
